@if (comment) {
    <div class="modal-inner">
        <h1>Aanpassen dagrapport {{ comment.user?.name }}</h1>
        <h2>{{ comment.date | date: 'EEEE dd MMMM yyyy' }} - {{ comment.afas_project_id }}</h2>
        @if (form) {
            <div class="w-100 mb-3">
                <simple-tiny class="w-100 mb-3" [showMenuBar]="false" [content]="form.controls.comment" height="300">
                </simple-tiny>
            </div>
        }
        <mat-error [control]="form.controls.comment"></mat-error>
        <div class="buttons">
            <button class="planning-button confirm" (click)="save()" mat-raised-button color="primary">Opslaan</button>
            <button
                class="planning-button cancel"
                (click)="dialogRef.close()"
                mat-raised-button
                color="basic"
                mat-dialog-close>
                Annuleren
            </button>
        </div>
    </div>
}
